// Module
var code = "<div id=\"calendar-wrapper\"> <div ng-if=\"false\"> <calendar is-online=\"vm.isOnline\" staff-user=\"vm.staffUser\"></calendar> </div> <div ng-if=\"true\"> <full-calendar is-online=\"vm.isOnline\" staff-user=\"vm.staffUser\"></full-calendar> </div> </div> ";
// Exports
module.exports = code;